/**
 * Módulo de tipos de documento — CRUD sin getById, con lista para selects
 */

import { createCrudMethods } from '../base/crudMethods';

/**
 * Crea el módulo de tipos de documento
 *
 * @param {Object} deps - Dependencias inyectadas
 * @param {Function} deps.authenticatedRequest - Función de request autenticada
 * @returns {Object} Métodos del módulo tipos de documento
 */
export function createTiposDocumentoModule({ authenticatedRequest }) {
  return {
    ...createCrudMethods(
      {
        endpoint: '/api/tipos-documento',
        entityName: 'tipoDocumento',
        entityNamePlural: 'tiposDocumento',
        methods: { getById: false, lista: true }
      },
      { authenticatedRequest }
    )
  };
}
